import './Navbar.css'
import MobileNavigation from '../components/MobileNavigation'

function openMobileNav() {
    const mobileNav = document.getElementById("mobile-navigation");
    mobileNav.style.display = "block";
}

export default function Navbar() {
    return (
        <div id = "navbar" style = {{display: 'flex', justifyContent: 'space-between'}}>
            <div id = "navbar-left">
                <a id = "logo" href = "/">KC SOCIAL NEST</a>
            </div>
            <div id = "navbar-right-desktop">
                <a className = "navbar-link" href = "/resources">Resources</a>
                <a className = "navbar-link" href = "/about">About</a>
                <a className = "navbar-link" href = "/chat">Chat</a>
            </div>
            <div id = "navbar-right-mobile">
                <a href = "#" id = "navbar-hamburger" onClick = {openMobileNav}>
                    <div className = "hamburger-line"></div>
                    <div className = "hamburger-line"></div>
                    <div className = "hamburger-line"></div>
                </a>
            </div>
            <MobileNavigation/>
        </div>
    )
}